import { render } from "./DRichTextEditor.vue?vue&type=template&id=75c08cae"
import script from "./DRichTextEditor.vue?vue&type=script&lang=js"
export * from "./DRichTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__